import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Temperature = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text16']),
        }}
      ></h1>
      <h5
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text17']),
        }}
      ></h5>

      <div className={styles.content}>
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-light.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-light-cover.jpg"
        ></video>
        <div className={styles.contentTextBox} data-speed="1.2">
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text18']),
            }}
          ></h5>
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text19']),
            }}
          ></h2>
        </div>
      </div>

      <div className={styles.imgBox}>
        <img
          className={styles.img1}
          src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-img-light-01.jpg"
          alt=""
        />
        <img
          className={styles.img2}
          data-speed="1.2"
          src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-img-light-02.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default Temperature;
